var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileOrgIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.333 4h2v1.333h-.667v7.334h.667V14H.666v-1.333h.667V5.333H.666V4h2V2.667A.667.667 0 0 1 3.333 2h9.333a.667.667 0 0 1 .667.667V4zm0 1.333H2.666v7.334h2V8h1.333v4.667h1.334V8h1.333v4.667h1.333V8h1.334v4.667h2V5.333zm-9.334-2V4h8v-.667H4z",
    fill: "#8496A9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileOrgIcon);
export default __webpack_public_path__ + "static/media/ProfileOrgIcon.0d601c8c6b66dbe191d3b6ee63330e28.svg";
export { ForwardRef as ReactComponent };